/*
# -----------------------------------------------------------------------------
# Component: riListMixin.js
# Author: ssy@pst.sg
# Created Date: 11/June/2019
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const riListMixin = {
  data() {
    return {
      queryMode: false,
      reviewRI: false,
      polTranRel: false,
      riTranRel: false,
      prevRel: false,
      disableRiBord: false,
      riHeaderItems: [],
      riOutBordItems: [],
      totalItemsRI: 0,
      totalItemsRiOutBord: 0,
      riDetailItems: [],
      totalItemsRiDetail: 0,
      riCoItems: [],
      totalItemsRiCo: 0,
      riTreatyItems: [],
      totalItemsRiTreaty: 0,
      riAcctNoSfxItems: [],
      riAcctNoSfxListItems: [],
      totalItemsRiAcctNoSfx: 0,
      selectedRIColumns: ['riType', 'riCoDesc', 'acctNoSfxWithDesc', 'cesEndtCnt', 'comDateDisp', 'expDateDisp'],
      selectedRIDetailColumns: [
        'riskNo',
        'riSI',
        'riSIPctDisp',
        'riPremDisp',
        'riComm1Disp',
        'riComm2Disp',
        'riComm3Disp',
        'riNetPremDisp',
        'riLevyDisp',
        'riTaxDisp'
      ],
      selectedRICoColumns: ['inter', 'name'],
      selectedRITreatyColumns: ['ttyNo', 'ttyDesc'],
      selectedRIAcctNoSfxColumns: ['acctNoSfx', 'description'],
      selectedRIOutBordColumns: ['itemNo', 'cedPolNo', 'riSI', 'riSIPct', 'riPrem', 'riComm1', 'riComm2', 'riComm3'],
      columns: [],
      defaultRIColumns: [
        { text: 'RI Type', value: 'riType' },
        { text: 'RI Company', value: 'riCoDesc' },
        { text: 'CessEndt Count', value: 'cesEndtCnt' },
        { text: 'Account Suffix', value: 'acctNoSfxWithDesc' },
        { text: 'Comm Date', value: 'comDateDisp' },
        { text: 'Expiry Date', value: 'expDateDisp' }
      ],
      riDetailColumns: [
        { text: 'Risk No.', value: 'riskNo' },
        { text: 'RI SI', value: 'riSI' },
        { text: 'RI %', value: 'riSIPct' },
        { text: 'RI %', value: 'riSIPctDisp' },
        { text: 'RI Premium', value: 'riPrem' },
        { text: 'RI Premium', value: 'riPremDisp' },
        { text: 'RI Comm 1', value: 'riComm1' },
        { text: 'RI Comm 1', value: 'riComm1Disp' },
        { text: 'RI Comm 2', value: 'riComm2' },
        { text: 'RI Comm 2', value: 'riComm2Disp' },
        { text: 'RI Comm 3', value: 'riComm3' },
        { text: 'RI Comm 3', value: 'riComm3Disp' },
        { text: 'RI Net Premium', value: 'riNetPrem' },
        { text: 'RI Net Premium', value: 'riNetPremDisp' },
        { text: 'RI Levy', value: 'riLevy' },
        { text: 'RI Levy', value: 'riLevyDisp' },
        { text: 'RI Tax', value: 'riTax' },
        { text: 'RI Tax', value: 'riTaxDisp' }
      ],
      riCoColumns: [
        { text: 'Intermediary No.', value: 'inter' },
        { text: 'Intermediary Name', value: 'name' }
      ],
      riTreatyColumns: [
        { text: 'Treaty No.', value: 'ttyNo' },
        { text: 'Treaty Descriction', value: 'ttyDesc' }
      ],
      riAcctNoSfxColumns: [
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Description', value: 'description' }
      ],
      riOutBordColumns: [
        { text: 'Item No.', value: 'itemNo' },
        { text: 'Ref No.', value: 'cedPolNo' },
        { text: 'RI Sum Insured', value: 'riSI' },
        { text: 'RI SI%', value: 'riSIPct' },
        { text: 'RI Premium', value: 'riPrem' },
        { text: 'RI Comm 1', value: 'riComm1' },
        { text: 'RI Comm 2', value: 'riComm2' },
        { text: 'RI Comm 3', value: 'riComm3' }
      ],
      paginationRI: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationRIHeaders: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationRiDetail: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 100
      },
      paginationRiCo: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationRiTreaty: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationRiAcctNoSfx: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationRiOutBord: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      riDetTotalHeader: [
        { text: '', value: '', width: 94 },
        { text: '', value: '', width: 94 },
        { text: '', value: '', width: 94 },
        { text: '', value: '', width: 94 },
        { text: 'riPrem', value: 'riPrem', width: 94 },
        { text: 'riComm1', value: 'riComm1', width: 94 },
        { text: 'riComm2', value: 'riComm2', width: 94 },
        { text: 'riComm3', value: 'riComm3', width: 94 },
        { text: 'riNetPrem', value: 'riNetPrem', width: 94 },
        { text: 'riLevy', value: 'riLevy', width: 94 },
        { text: 'riTax', value: 'riTax', width: 94 }
      ],
      riDetTotal: [{ riPrem: 0, riComm1: 0, riComm2: 0, riComm3: 0, riNetPrem: 0, riLevy: 0, riTax: 0 }],
      firstRiHeaderReload: true,
      fetchRiDetailReload: true
    }
  },
  computed: {
    listRIHeaders() {
      let result = []
      for (const selectedRIColumn of this.selectedRIColumns) {
        let findCol = this.defaultRIColumns.find(a => selectedRIColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listRIDetails() {
      let result = []
      for (const selectedRIDetailColumn of this.selectedRIDetailColumns) {
        let findCol = this.riDetailColumns.find(a => selectedRIDetailColumn === a.value)
        findCol.width = 94
        findCol.maxWidth = 94
        findCol.minWidth = 94
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listRICo() {
      let result = []
      for (const selectedRICoColumn of this.selectedRICoColumns) {
        let findCol = this.riCoColumns.find(a => selectedRICoColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listRITreaty() {
      let result = []
      for (const selectedRITreatyColumn of this.selectedRITreatyColumns) {
        let findCol = this.riTreatyColumns.find(a => selectedRITreatyColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listRIAcctNoSfx() {
      let result = []
      for (const selectedRIAcctNoSfxColumn of this.selectedRIAcctNoSfxColumns) {
        let findCol = this.riAcctNoSfxColumns.find(a => selectedRIAcctNoSfxColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listRIOutBord() {
      let result = []
      for (const selectedRIOutBordColumn of this.selectedRIOutBordColumns) {
        let findCol = this.riOutBordColumns.find(a => selectedRIOutBordColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    // RI Headers
    'paginationRIHeaders': function(value) {
      this.doFetchRIHeaders(false)
    },
    // RI Header
    'paginationRI': function(value) {
      if (!this.firstRiHeaderReload) {
        this.doFetch(false)
      }
    },
    // RI Detail
    'paginationRiDetail': function(value) {
      if (!this.fetchRiDetailReload) {
        this.doReview(this.selectedRow)
      }
    },
    // RI Header Create(Company)
    'paginationRiCo': function(value) {
      this.riCoInit(false)
    },
    // RI Header Create(Treaty)
    'paginationRiTreaty': function(value) {
      this.riTreatyInit(false)
    },
    // RI Header Create(AcctNoSfx)
    'paginationRiAcctNoSfx': function(value) {
      this.riAcctNoSfxInit(5)
    },
    // RI Bordereaux
    'paginationRiOutBord': function(value) {
      this.doFetchRiOutBordList(this.riDetailForm)
    }
  },
  mounted() {},
  mixins: [TableConst.default, MessageMixin]
}
